(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("massive-point-cloud", [], factory);
	else if(typeof exports === 'object')
		exports["massive-point-cloud"] = factory();
	else
		root["massive-point-cloud"] = factory();
})(self, function() {
return 